import React, { useState, useEffect } from "react";
import { injectModels } from "../../redux/injectModels";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import Lottie from "lottie-react";
import Modal from "react-bootstrap/Modal";
import generateSopAnimation from "../../Animation/create_sop.json";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai"; // icons form react-icons
import { IconContext } from "react-icons";

const Complete = (props) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const role = localStorage.getItem("userRole");

  const rowsPerPage = 8;
  const offset = currentPage * rowsPerPage;
  let paginatedData = [];
  try {
    if (Array.isArray(filteredData)) {
      paginatedData = filteredData.slice(offset, offset + rowsPerPage);
    } else {
      throw new Error("filteredData is not an array");
    }
  } catch (exception) {
    paginatedData = [];
    console.log(exception);
  }
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);

    if (selected === 0) {
      setShowPreviousButton(false);
    } else {
      setShowPreviousButton(true);
    }

    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (selected === pageCount - 1 || pageCount === 1) {
      setShowNextButton(false);
    } else {
      setShowNextButton(true);
    }
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          pageClassName={"page-item"}
          pageCount={pageCount}
          pageRangeDisplayed={0}
          marginPagesDisplayed={2}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          containerClassName="pagination"
          activeClassName="active"
          breakLabel="..."
          previousLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillLeftCircle />
            </IconContext.Provider>
          }
          nextLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillRightCircle />
            </IconContext.Provider>
          }
          renderOnZeroPageCount={null}
          disableInitialCallback={true}
        />
      );
    }
    return null;
  };

  useEffect(() => {
    getCompleteSession();
    handleDownloadSop();
  }, []);

  const getCompleteSession = async () => {
    props.application.setLoading(true);
    try {
      const res = await props.admin.getAllCompleteSession();
      if (res) {
        setFilteredData(res.session);
      } else {
        toast.error("Failed to fetch sessions", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      props.application.setLoading(false);
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleGenerateSop = async (id) => {
    try {
      
      handleShow();
      const res = await props.admin.createSop(id);
      if (res.success === true) {
        toast.success(res.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        handleDownloadSop();
        handleClose();
      } else {
        toast.error(res.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        handleClose();
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
      handleClose();
    }
  };

  const handleDownloadSop = async () => {
    try {
      
      props.application.setLoading(true);
      const res = await props.admin.downloadSop();
      if (res.success) {
        setData(res.session);
        props.application.setLoading(false);
      } else {
        toast.error(res.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        props.application.setLoading(false);
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
      props.application.setLoading(false);
    }
  };

  const handleDeleteSession = async (id) => {
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#009462",
      cancelButtonColor: "#314a5f",
      confirmButtonText: `Yes`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          props.application.setLoading(true);
          const res = await props.admin.deleteSession(id);
          if (res.success === true) {
            toast.dismiss();
            toast.success(res.message, {
              position: toast.POSITION.TOP_CENTER,
            });
            getCompleteSession();
            props.application.setLoading(false);
          } else {
            props.application.setLoading(false);
            toast.dismiss();
            toast.success(res.message, {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        } catch (error) {
          console.log(error);
          props.application.setLoading(false);
          toast.dismiss();
          toast.success("Something went wrong!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    });
  };

  const formatDateTime = (apiTime) => {
    const date = new Date(apiTime);

    // Extract date components
    const day = String(date.getDate()).padStart(2, "0"); // Day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month (0-indexed) with leading zero
    const year = date.getFullYear();

    // Extract time components
    const hours = date.getHours() % 12 || 12; // Convert to 12-hour format
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Leading zero for minutes
    const seconds = String(date.getSeconds()).padStart(2, "0"); // Leading zero for seconds
    const ampm = date.getHours() >= 12 ? "PM" : "AM"; // AM/PM

    // Combine date and time in desired format
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  return (
    <>
      <div
        className="tab-pane fade"
        id="pills-profile"
        role="tabpanel"
        aria-labelledby="profile-tab"
      >
        <table className="table table-bordered ">
          <thead>
            <tr>
              {role === "admin" && <th>User name</th>}
              <th>Title</th>
              <th>Date</th>
              <th>Duration</th>
              <th>Job profile</th>
              <th>Company</th>
              <th>Interviewer (client)</th>
              <th>Interviewee (user)</th>
              <th>Topic</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((item, index) => (
                <tr key={index}>
                  {role === "admin" && <td>{item.username}</td>}
                  <td>{item.title}</td>
                  <td> {formatDateTime(item.end_time)}</td>
                  <td>{item.duration}</td>
                  <td>{item.job_profile}</td>
                  <td>{item.company_name}</td>
                  <td>{item.client}</td>
                  <td>{item.user}</td>
                  <td>{item.topic}</td>
                  <td
                    style={{
                      display: "flex",
                      alignItems: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {!data.some((dta) => item.id === dta.id) && (
                      <button
                        className="btn btn-secondary btn-sm m-0"
                        onClick={() => handleGenerateSop(item.id)}
                      >
                        Generate Sop
                      </button>
                    )}
                    {data
                      .filter((dta) => item.id === dta.id)
                      .map((dta, index) => (
                        <React.Fragment key={index}>
                          {dta.prompt_file !== "" ? (<>
                            <a
                              className="btn btn-dark btn-sm m-0"
                              href={dta.prompt_file}
                              download
                            >
                              Prompt Data
                            </a>
                             </>
                          ) : (
                            <button className="btn btn-sm prompt_not">
                              Prompt Data
                            </button>
                          
                          )}
                          &nbsp;
                          <a
                            className="btn btn-primary btn-sm m-0"
                            href={dta.file}
                            download
                          >
                            <i className="fa-solid fa-download"></i>
                          </a>
                          &nbsp;
                          <Link
                            to={`/session/editsop/${dta.id}`}
                            className="btn btn-success btn-sm m-0"
                          >
                            <i className="bi bi-eye-fill"></i>
                          </Link>
                        </React.Fragment>
                      ))}
                    &nbsp;
                    <button
                      className="btn btn-danger btn-sm m-0"
                      onClick={() => handleDeleteSession(item.id)}
                    >
                      <i className="bi bi-trash-fill"></i>
                    </button>
                    &nbsp;
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No results found!
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="table-footer">
          <strong>Total Count: {filteredData.length}</strong>
          {renderPagination()}
        </div>
      </div>

      <Modal
        show={show}
        size="md"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Lottie
            style={{ height: 250 }}
            animationData={generateSopAnimation}
            loop={true}
          />
          <p
            style={{
              margin: "auto",
              justifyContent: "center",
              fontSize: "16px",
              display: "flex",
              fontWeight: "bold",
              marginTop: 0,
              color: "#616161",
            }}
          >
            It will take a few minutes to create the SOP.
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default injectModels(["admin", "application"])(Complete);
